var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("share-tab")))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.allUsers, function (user) {
              return _c(
                "w-list-item",
                { key: user.ID },
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(user.getShortDisplayName())),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c("w-switch", {
                        attrs: { value: _vm.isUserChecked(user.ID) },
                        on: {
                          input: function ($event) {
                            return _vm.setUserChecked(user.ID, $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }